<template>
  <div class="secure-project-column">
    {{ value ? "Yes" : "No" }}
  </div>
</template>

<script setup lang="ts">

import {computed, toRefs} from "vue";

  const props = withDefaults(defineProps<{
    row: any,
    value?: boolean | null,
  }>(), {
    value: false,
  });
  const {
    row,
    value,
  } = toRefs(props);

  const emit = defineEmits<{
    'click': [any],
  }>();

</script>

<style scoped lang="scss">
    .secure-project-column {
      max-width: 200px;
    }
</style>